import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    const makePutRequest = ({ data, url }) =>
      $.ajax({
        url,
        type: 'PUT',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        statusCode: {
          200: () => renderCategoryTable(),
        },
      });
    const renderCategoryTable = () => {
      const categoryId = document.body.dataset.actionCategoryId;

      $.get(`/u/admin/videos/${categoryId}/xhr_category_table`, (table) => {
        const responseTable = new DOMParser().parseFromString(table, 'text/html');
        const categoryTbody = document.querySelector(`tbody[data-category-id="${categoryId}"]`);

        // By replacing only the tbody we don't have to setup sortable again.
        categoryTbody.innerHTML = responseTable.querySelector('tbody').innerHTML;
      });
    };
    // Returns an array of objects representing each table rendered;
    //
    // [
    //   {
    //     children: [],
    //     id: 1,
    //     type: 'category'
    //   }
    // ]
    //
    // Every category is at the top level. `children` can contain videos and/or
    // subcategories (with its respective type).
    const tableStatus = () => {
      return Array.from(document.querySelectorAll('tbody[data-category-id]')).map((table) => {
        const { categoryId } = table.dataset;

        const { children, lastSubcategory } = Array.from(table.querySelectorAll('tbody tr')).reduce(
          ({ children, lastSubcategory }, tr) => {
            const { adminVideoDraggable, adminSubcategoryDraggable, videoId, subcategoryId } =
              tr.dataset;

            if (adminVideoDraggable === 'true') {
              const videoData = {
                children: [],
                id: videoId,
                type: 'video',
              };

              if (lastSubcategory) {
                return {
                  children,
                  lastSubcategory: {
                    ...lastSubcategory,
                    children: [...lastSubcategory.children, videoData],
                  },
                };
              } else {
                return {
                  children: [...children, videoData],
                  lastSubcategory,
                };
              }
            }

            if (adminSubcategoryDraggable === 'true') {
              const newSubcategory = {
                children: [],
                id: subcategoryId,
                type: 'subcategory',
              };

              return {
                children: lastSubcategory ? [...children, lastSubcategory] : children,
                lastSubcategory: newSubcategory,
              };
            }

            return { children, lastSubcategory };
          },
          { children: [], lastSubcategory: null }
        );

        return {
          children: lastSubcategory ? [...children, lastSubcategory] : children,
          id: categoryId,
          type: 'category',
        };
      });
    };

    if ($('body').is('#admin-videos')) {
      $('[data-admin-videos-sortable]').sortable({
        items: 'tr',
        cursor: 'move',
        tolerance: 'pointer',
        cancel: '[data-admin-subcategory-draggable]',
        stop: (event, ui) => {
          // Searches for the parent and position of the given element.
          const findParentAndPositionById = ({ data = tableStatus(), id, type }) => {
            for (const node of data) {
              const filteredChildren = node.children.filter((child) => child.type === type);

              for (const [i, child] of filteredChildren.entries()) {
                if (child.id === id) {
                  return {
                    parent: node,
                    position: i + 1,
                  };
                }
              }

              for (const child of node.children) {
                if (child.type === 'subcategory') {
                  const found = findParentAndPositionById({
                    data: [child],
                    id,
                    type,
                  });

                  if (found) {
                    return found;
                  }
                }
              }
            }

            return null;
          };

          const item = ui.item[0];
          const { target } = event;
          const { dataset } = item;

          // Store the parent category of the video/subcategory to
          // be used then in the request callback.
          document.body.dataset.actionCategoryId = target.closest('tbody').dataset.categoryId;

          if (dataset.adminVideoDraggable === 'true') {
            const id = dataset.videoId;
            const { parent, position } = findParentAndPositionById({ id, type: 'video' });

            makePutRequest({
              data: {
                video: {
                  id,
                  sort_order: position,
                  video_category_id: parent.id,
                },
              },
              url: `/u/admin/videos/${id}`,
            });
          }

          if (dataset.adminSubcategoryDraggable === 'true') {
            const id = dataset.subcategoryId;
            const { parent, position } = findParentAndPositionById({ id, type: 'subcategory' });

            makePutRequest({
              data: {
                video_category: {
                  id,
                  sort_order: position,
                  parent_id: parent.id,
                },
              },
              url: `/u/admin/video_categories/${id}`,
            });
          }
        },
      });
    }

    if ($('body').is('#admin-videos-new')) {
      $(document).on('keyup paste change', '#video_name', (e) => {
        const regex = /[^0-9a-z- ]/gi;
        $('#video_video_id').val(
          $(e.target).val().toLowerCase().replaceAll(regex, '').replaceAll(' ', '-')
        );
      });
    }

    if ($('body').is('#admin-videos-new') || $('body').is('#admin-videos-edit')) {
      $(document).on('paste change', '#video_embed_url', (e) => {
        const embedUrl = $(e.target).val();
        if (embedUrl.includes('/embed/')) {
          $('.error-message--video-embed-url').hide();
          const youtubeId = embedUrl.split('/embed/')[1].split('?')[0];
          $('#video_image_url').val(`https://img.youtube.com/vi_webp/${youtubeId}/sddefault.webp`);
        } else {
          $('.error-message--video-embed-url').show();
        }
      });
    }
  });
});
